import React from "react";
import ClientSearchDropdown from "../../../../models/ClientSearchDropdown";
// import "../../../../../../css/pages/ca_pages/finances/models/client_payments_model/ClientSection.css";

const ClientSection = ({
    selectedClient,
    onSelect,
    onClear,
    error,
}) => {
    return (
        <section className="payment-form-section">
            <div className="section-heading">
                <h3>Client</h3>

                <span>
                    Select the client who should
                    receive this payment request.
                </span>
            </div>

            {!selectedClient ? (
                <>
                    <ClientSearchDropdown onSelect={onSelect} />

                    {error && (
                        <small className="field-error">
                            {error}
                        </small>
                    )}
                </>
            ) : (
                <div className="selected-client">
                    <div className="selected-client-info">
                        <div className="client-avatar">
                            {selectedClient
                                .user_full_name
                                ?.charAt(0)
                                ?.toUpperCase()}
                        </div>

                        <div>
                            <strong>
                                { selectedClient.user_full_name }
                            </strong>

                            <small>
                                { selectedClient.email }
                            </small>
                        </div>
                    </div>

                    <button type="button" onClick={onClear}>
                        Change
                    </button>
                </div>
            )}
        </section>
    );
};

export default ClientSection;
